/* eslint-disable no-redeclare */

import { z } from 'zod';

export const CallStatus = z.enum([
  'ON_CALL',
  'ENDED_TOO_QUICKLY',
  'ENDED',
  'IDLE',
]);

export type CallStatus = z.infer<typeof CallStatus>;
